// extracted by mini-css-extract-plugin
export default {"root":"photo-field-module_root-tnvzO"};